// extracted by mini-css-extract-plugin
export default {"tunde_Container":"Tunde_tunde_Container__6IckR","tunde_Wrapper":"Tunde_tunde_Wrapper__BFv1-","tunde_Link":"Tunde_tunde_Link__9zDnn"};